(() => {
  const brand = document.querySelector('.nav .brand');
  const menu = document.querySelector('.mobile-nav-menu');
  if (!brand || !menu) return;

  brand.addEventListener('click', (event) => {
    if (!window.matchMedia('(max-width: 760px)').matches) return;
    event.preventDefault();
    const open = menu.classList.toggle('is-open');
    brand.setAttribute('aria-expanded', String(open));
  });

  document.addEventListener('click', (event) => {
    if (!menu.classList.contains('is-open') || brand.contains(event.target) || menu.contains(event.target)) return;
    menu.classList.remove('is-open');
    brand.setAttribute('aria-expanded', 'false');
  });
})();
